export const DEFAULT_FOOTER_MARKUP = {
  settings: '',
  markup: '',
};

export const DEFAULT_HEADER_MARKUP = Object.assign(DEFAULT_FOOTER_MARKUP);
